@import "../config/_helpers";
.mini-cart-container {
	position: relative;
	z-index: 20;
	--bg-color: var(--quarternary-color-light-6);
	--bg-color: #f4f4f4;

	color: black;
	// color: #1D3146;

	.mini-cart.basket-container {
		max-height: 500px;
		position: absolute;
		cursor: normal;
		top: calc(100% + 20px);
		right: -5px;
		opacity: 0;
		pointer-events: none;
		transition: 0.2s opacity ease-in-out;
		font-size: small;
		transform: translateX(25%);
		overflow-y: auto;

		@include at-breakpoint(0, $l) {
			position: fixed;
			right: 0;
			transform: none;
			top: 100px;
		}

		&:after {
			content: "";
			background-image: linear-gradient(-45deg, transparent 50%, var(--bg-color) 51%);
			height: 30px;
			width: 30px;
			position: absolute;
			transform: rotate(45deg);
			top: -13px;
			right: 25%;
			border-width: 1px 0 0 1px;
			border-style: solid;
			border-color: rgba(0, 0, 0, 0.1);
			z-index: 2;
			margin-right: 10px;
			pointer-events: none;
			transition: 0.2s opacity ease-in-out;

			@include at-breakpoint(0, $l) {
				right: 15px;
			}
		}

		&.active {
			opacity: 1;
			z-index: 20;
			.basket-container-wrapper {
				pointer-events: all;
			}
		}
		.basket-container-wrapper {
			width: 100vw;
			max-width: 450px;
			min-height: 400px;
			background: var(--bg-color);
			// overflow: auto;
			border-radius: 10px;
			border: 1px solid rgba(0, 0, 0, 0.1);
			padding: 10px;
			position: relative;
			margin-left: auto;
			display: flex;
			flex-direction: column;
			.basket-container-subtitle {
				border-bottom: 1px solid rgba(0, 0, 0, 0.05);
				// border-bottom: 1px solid rgba(255,255,255,0.1);
				padding: 20px 10px;
				user-select: none;
				h3 {
					font-size: larger;
					font-weight: bold;
				}
				.remove-all-button {
					text-align: right;
					color: var(--tertiary-color);
					font-size: small;
					cursor: pointer;
					&:hover {
						color: var(--tertiary-color-dark-1);
						text-decoration: underline;
					}
				}
			}

			.basket-items {
				max-height: 200px;
				flex: 1 0 250px;
				overflow: auto;
				// --scroll-thumb-color: rgba(255,255,255,0.3);
				.empty-cart {
					padding: 20px;
					text-align: center;
				}
			}

			.basket-continue {
				border-top: 1px dashed rgba(0, 0, 0, 0.05);
				padding: 20px 10px 10px;
				margin-top: auto;

				h3 {
					display: flex;
					align-items: center;
					justify-content: space-between;
					font-size: larger;
					flex-wrap: wrap;
					font-weight: bold;
					// margin-bottom: 20px;
					hr {
						flex: 0 0 100%;
					}
				}

				.loading-animation h3 {
					justify-content: center;
				}
				button,
				.btn {
					width: 100%;
					font-size: 14px;
					padding: 10px;
				}

				.payment-form {
					.container {
						padding: 0;
					}

					.invoice-payment {
						padding-left: 0;
						padding-right: 0;
					}
				}
			}
		}
		.braintree-dropin {
			.braintree-heading {
				// color: white;
			}
		}
		.paypal-buttons {
			position: relative;
			z-index: 1;
			margin-bottom: 20px;
		}
	}
}
